import { render, staticRenderFns } from "./chooseAddressDialog.vue?vue&type=template&id=261b1eb8"
import script from "./chooseAddressDialog.vue?vue&type=script&lang=js"
export * from "./chooseAddressDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseAddressDialog.vue?vue&type=style&index=0&id=261b1eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports